<template>
  <b-form @submit.prevent="onSubmit" novalidate>
    <b-form-group label-for="input-first-name">
      <template #label>
        First Name*
      </template>
      <b-form-input id="input-first-name" v-model="form.firstName" :state="isValidField('firstName')" placeholder="eg., Ericka" class="rounded-pill" />
      <b-form-invalid-feedback :state="isValidField('firstName')">
        <div v-for="error in errors.firstName || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label-for="input-last-name">
      <template #label>
        Last Name*
      </template>
      <b-form-input id="input-last-name" v-model="form.lastName" :state="isValidField('lastName')" placeholder="eg., Jones" class="rounded-pill" />
      <b-form-invalid-feedback :state="isValidField('lastName')">
        <div v-for="error in errors.lastName || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label-for="input-password">
      <template #label>
        <b-row no-gutters>
          <b-col>
            Password*
          </b-col>
          <b-col cols="auto" class="align-self-end mr-2">
            <h6 class="m-0">
              <b-link href class="btn-link-dark" tabindex="-1" @click.prevent.stop="showPwd">
                <keep-alive>
                  <component :is="eyeIcon" font-scale="1.3" class="mr-2" />
                </keep-alive>
                <template v-if="showPass">Hide</template>
                <template v-else>Show</template>
              </b-link>
            </h6>
          </b-col>
        </b-row>
      </template>
      <b-form-input
        id="input-password"
        :type="passwordType"
        v-model="form.password"
        :state="isValidField('password')"
        placeholder="Password"
        class="rounded-pill"
        @input="onInputPass"
      />
    </b-form-group>
    <b-form-group class="invalid-line">
      <b-row>
        <b-col cols="12" md="6" :class="{ 'valid-line': passedRules[PasswordRules.ONE_LOWER_LETTER] === true }">
          <b-icon-circle-fill font-scale=".9" class="mr-1" /> one lowercase character
        </b-col>
        <b-col cols="12" md="6" :class="{ 'valid-line': passedRules[PasswordRules.ONE_SPECIAL_CHAR] === true }">
          <b-icon-circle-fill font-scale=".9" class="mr-1" /> one special character
        </b-col>
        <b-col cols="12" md="6" :class="{ 'valid-line': passedRules[PasswordRules.ONE_UPPER_LETTER] === true }">
          <b-icon-circle-fill font-scale=".9" class="mr-1" /> one uppercase character
        </b-col>
        <b-col cols="12" md="6" :class="{ 'valid-line': passedRules[PasswordRules.MIN_LENGTH] === true }">
          <b-icon-circle-fill font-scale=".9" class="mr-1" /> 8 characters minimum
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-invalid-feedback :state="isValidField('key')">
      <div v-for="error in errors.key || []" :key="error">
        {{ error }}
      </div>
    </b-form-invalid-feedback>
    <b-form-row class="mt-5">
      <b-col />
      <b-col cols="auto">
        <b-button type="submit" :disabled="submitting" pill variant="primary" class="pl-5 pr-5">Next</b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import { BIconEyeFill, BIconEyeSlashFill, BIconCircleFill } from 'bootstrap-vue'
import validator from 'validator'
import MixinForm from '../MixinForm'
import { PASSWORD_RULE_TYPE, isValidPassword } from '@/helpers/password'

export default {
  name: 'IdentityForm',

  mixins: [MixinForm],

  props: {
    verifyKey: {
      type: String,
      required: true
    }
  },

  computed: {
    passwordType() {
      return this.showPass ? 'text' : 'password'
    },

    eyeIcon() {
      return this.showPass ? BIconEyeSlashFill : BIconEyeFill
    }
  },

  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        password: '',
        key: this.verifyKey
      },
      PasswordRules: PASSWORD_RULE_TYPE,
      showPass: false,
      passedRules: {}
    }
  },

  methods: {
    showPwd() {
      this.showPass = !this.showPass
    },

    onInputPass(value) {
      this.validatePass(value)
    },

    validatePass(value) {
      const result = isValidPassword(value)
      this.passedRules = result.parts
      return result.isValid
    },

    validate(data) {
      const errors = {}
      if (validator.isEmpty(data.firstName)) errors.firstName = ["First name can't be blank"]
      if (validator.isEmpty(data.lastName)) errors.lastName = ["Last name can't be blank"]
      if (!this.validatePass(data.password)) errors.password = ['Invalid password']
      return errors
    }
  },

  components: {
    BIconEyeFill,
    BIconEyeSlashFill,
    BIconCircleFill
  }
}
</script>
